<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 14 / 17"
    viewBox="0 0 17 14"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M15.76 12.947H1.338V3.579a.526.526 0 1 0-1.053 0v9.894c0 .29.236.526.526.526H15.76a.526.526 0 1 0 0-1.052z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M9.812 8.035H7.128a.526.526 0 0 0-.526.526v4.912h1.052V9.087h1.632v4.386h1.052V8.561a.526.526 0 0 0-.526-.526z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M14.408 4.982h-2.684a.526.526 0 0 0-.526.527v7.964h1.052V6.035h1.632v7.438h1.053V5.51a.526.526 0 0 0-.527-.527z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M5.216 10.14H2.532a.526.526 0 0 0-.527.526v2.807h1.053v-2.28h1.631v2.28h1.053v-2.807a.526.526 0 0 0-.526-.526z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M10.164.278C7.28 6.193.822 6.943.757 6.95l.055.523.055.524c.288-.03 7.098-.806 10.243-7.258z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M11.854 3.669L11.205.423a.526.526 0 0 0-.619-.413L7.341.66a.526.526 0 1 0 .206 1.032l2.73-.546.545 2.73a.526.526 0 1 0 1.032-.207z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>
